var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invis"},[_vm._v("secs:"+_vm._s(_vm.remSecs))])}
var staticRenderFns = []

export { render, staticRenderFns }